export default "__VITE_ASSET__BXP1_bQ3__ 720w";